// Auth Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

// Customer Types
export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE';
export const CREATE_CUSTOMER_REQUEST = 'CREATE_CUSTOMER_REQUEST';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';
export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAILURE = 'UPDATE_CUSTOMER_FAILURE';
export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_FAILURE = 'DELETE_CUSTOMER_FAILURE';

// Product Types
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
export const CREATE_PRODUCT_REQUEST = 'CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';
export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
export const GET_LOW_STOCK_REQUEST = 'GET_LOW_STOCK_REQUEST';
export const GET_LOW_STOCK_SUCCESS = 'GET_LOW_STOCK_SUCCESS';
export const GET_LOW_STOCK_FAILURE = 'GET_LOW_STOCK_FAILURE';

// Invoice Types
export const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE';
export const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_FAILURE = 'CREATE_INVOICE_FAILURE';
export const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
export const UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_FAILURE = 'UPDATE_INVOICE_FAILURE';
export const GET_INVOICE_REQUEST = 'GET_INVOICE_REQUEST';
export const GET_INVOICE_SUCCESS = 'GET_INVOICE_SUCCESS';
export const GET_INVOICE_FAILURE = 'GET_INVOICE_FAILURE';
export const GENERATE_PDF_REQUEST = 'GENERATE_PDF_REQUEST';
export const GENERATE_PDF_SUCCESS = 'GENERATE_PDF_SUCCESS';
export const GENERATE_PDF_FAILURE = 'GENERATE_PDF_FAILURE';
export const GET_SALES_SUMMARY_REQUEST = 'GET_SALES_SUMMARY_REQUEST';
export const GET_SALES_SUMMARY_SUCCESS = 'GET_SALES_SUMMARY_SUCCESS';
export const GET_SALES_SUMMARY_FAILURE = 'GET_SALES_SUMMARY_FAILURE';
export const GET_INVOICE_PAYMENTS_REQUEST = 'GET_INVOICE_PAYMENTS_REQUEST';
export const GET_INVOICE_PAYMENTS_SUCCESS = 'GET_INVOICE_PAYMENTS_SUCCESS';
export const GET_INVOICE_PAYMENTS_FAILURE = 'GET_INVOICE_PAYMENTS_FAILURE';
export const CANCEL_INVOICE_REQUEST = 'CANCEL_INVOICE_REQUEST';
export const CANCEL_INVOICE_SUCCESS = 'CANCEL_INVOICE_SUCCESS';
export const CANCEL_INVOICE_FAILURE = 'CANCEL_INVOICE_FAILURE';

// Customer Order Types
export const GET_CUSTOMER_ORDERS_REQUEST = 'GET_CUSTOMER_ORDERS_REQUEST';
export const GET_CUSTOMER_ORDERS_SUCCESS = 'GET_CUSTOMER_ORDERS_SUCCESS';
export const GET_CUSTOMER_ORDERS_FAILURE = 'GET_CUSTOMER_ORDERS_FAILURE';
export const GET_CUSTOMER_ORDER_REQUEST = 'GET_CUSTOMER_ORDER_REQUEST';
export const GET_CUSTOMER_ORDER_SUCCESS = 'GET_CUSTOMER_ORDER_SUCCESS';
export const GET_CUSTOMER_ORDER_FAILURE = 'GET_CUSTOMER_ORDER_FAILURE';
export const CREATE_CUSTOMER_ORDER_REQUEST = 'CREATE_CUSTOMER_ORDER_REQUEST';
export const CREATE_CUSTOMER_ORDER_SUCCESS = 'CREATE_CUSTOMER_ORDER_SUCCESS';
export const CREATE_CUSTOMER_ORDER_FAILURE = 'CREATE_CUSTOMER_ORDER_FAILURE';
export const UPDATE_CUSTOMER_ORDER_REQUEST = 'UPDATE_CUSTOMER_ORDER_REQUEST';
export const UPDATE_CUSTOMER_ORDER_SUCCESS = 'UPDATE_CUSTOMER_ORDER_SUCCESS';
export const UPDATE_CUSTOMER_ORDER_FAILURE = 'UPDATE_CUSTOMER_ORDER_FAILURE';
export const ASSIGN_GOLDSMITH_REQUEST = 'ASSIGN_GOLDSMITH_REQUEST';
export const ASSIGN_GOLDSMITH_SUCCESS = 'ASSIGN_GOLDSMITH_SUCCESS';
export const ASSIGN_GOLDSMITH_FAILURE = 'ASSIGN_GOLDSMITH_FAILURE';
export const ADD_ORDER_PAYMENT_REQUEST = 'ADD_ORDER_PAYMENT_REQUEST';
export const ADD_ORDER_PAYMENT_SUCCESS = 'ADD_ORDER_PAYMENT_SUCCESS';
export const ADD_ORDER_PAYMENT_FAILURE = 'ADD_ORDER_PAYMENT_FAILURE';
export const GET_ORDER_PAYMENTS_REQUEST = 'GET_ORDER_PAYMENTS_REQUEST';
export const GET_ORDER_PAYMENTS_SUCCESS = 'GET_ORDER_PAYMENTS_SUCCESS';
export const GET_ORDER_PAYMENTS_FAILURE = 'GET_ORDER_PAYMENTS_FAILURE';

// Goldsmith Purchase Types
export const GET_GOLDSMITH_PURCHASES_REQUEST = 'GET_GOLDSMITH_PURCHASES_REQUEST';
export const GET_GOLDSMITH_PURCHASES_SUCCESS = 'GET_GOLDSMITH_PURCHASES_SUCCESS';
export const GET_GOLDSMITH_PURCHASES_FAILURE = 'GET_GOLDSMITH_PURCHASES_FAILURE';
export const GET_GOLDSMITH_PURCHASE_REQUEST = 'GET_GOLDSMITH_PURCHASE_REQUEST';
export const GET_GOLDSMITH_PURCHASE_SUCCESS = 'GET_GOLDSMITH_PURCHASE_SUCCESS';
export const GET_GOLDSMITH_PURCHASE_FAILURE = 'GET_GOLDSMITH_PURCHASE_FAILURE';
export const CREATE_GOLDSMITH_PURCHASE_REQUEST = 'CREATE_GOLDSMITH_PURCHASE_REQUEST';
export const CREATE_GOLDSMITH_PURCHASE_SUCCESS = 'CREATE_GOLDSMITH_PURCHASE_SUCCESS';
export const CREATE_GOLDSMITH_PURCHASE_FAILURE = 'CREATE_GOLDSMITH_PURCHASE_FAILURE';
export const UPDATE_GOLDSMITH_PURCHASE_REQUEST = 'UPDATE_GOLDSMITH_PURCHASE_REQUEST';
export const UPDATE_GOLDSMITH_PURCHASE_SUCCESS = 'UPDATE_GOLDSMITH_PURCHASE_SUCCESS';
export const UPDATE_GOLDSMITH_PURCHASE_FAILURE = 'UPDATE_GOLDSMITH_PURCHASE_FAILURE';
export const GET_TODAY_GOLD_RATE_REQUEST = 'GET_TODAY_GOLD_RATE_REQUEST';
export const GET_TODAY_GOLD_RATE_SUCCESS = 'GET_TODAY_GOLD_RATE_SUCCESS';
export const GET_TODAY_GOLD_RATE_FAILURE = 'GET_TODAY_GOLD_RATE_FAILURE';
export const GET_PURCHASE_PAYMENTS_REQUEST = 'GET_PURCHASE_PAYMENTS_REQUEST';
export const GET_PURCHASE_PAYMENTS_SUCCESS = 'GET_PURCHASE_PAYMENTS_SUCCESS';
export const GET_PURCHASE_PAYMENTS_FAILURE = 'GET_PURCHASE_PAYMENTS_FAILURE';

// Old Metal Types
export const GET_OLD_METAL_TYPES_REQUEST = 'GET_OLD_METAL_TYPES_REQUEST';
export const GET_OLD_METAL_TYPES_SUCCESS = 'GET_OLD_METAL_TYPES_SUCCESS';
export const GET_OLD_METAL_TYPES_FAILURE = 'GET_OLD_METAL_TYPES_FAILURE';
export const GET_OLD_METAL_STOCK_REQUEST = 'GET_OLD_METAL_STOCK_REQUEST';
export const GET_OLD_METAL_STOCK_SUCCESS = 'GET_OLD_METAL_STOCK_SUCCESS';
export const GET_OLD_METAL_STOCK_FAILURE = 'GET_OLD_METAL_STOCK_FAILURE';
export const UPDATE_OLD_METAL_STOCK_REQUEST = 'UPDATE_OLD_METAL_STOCK_REQUEST';
export const UPDATE_OLD_METAL_STOCK_SUCCESS = 'UPDATE_OLD_METAL_STOCK_SUCCESS';
export const UPDATE_OLD_METAL_STOCK_FAILURE = 'UPDATE_OLD_METAL_STOCK_FAILURE';
export const GET_OLD_METAL_EXCHANGES_REQUEST = 'GET_OLD_METAL_EXCHANGES_REQUEST';
export const GET_OLD_METAL_EXCHANGES_SUCCESS = 'GET_OLD_METAL_EXCHANGES_SUCCESS';
export const GET_OLD_METAL_EXCHANGES_FAILURE = 'GET_OLD_METAL_EXCHANGES_FAILURE';
export const GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST = 'GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST';
export const GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS = 'GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS';
export const GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE = 'GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE';

// Chit Types
export const GET_CHIT_GROUPS_REQUEST = 'GET_CHIT_GROUPS_REQUEST';
export const GET_CHIT_GROUPS_SUCCESS = 'GET_CHIT_GROUPS_SUCCESS';
export const GET_CHIT_GROUPS_FAILURE = 'GET_CHIT_GROUPS_FAILURE';
export const CREATE_CHIT_GROUP_REQUEST = 'CREATE_CHIT_GROUP_REQUEST';
export const CREATE_CHIT_GROUP_SUCCESS = 'CREATE_CHIT_GROUP_SUCCESS';
export const CREATE_CHIT_GROUP_FAILURE = 'CREATE_CHIT_GROUP_FAILURE';
export const GET_CUSTOMER_CHITS_REQUEST = 'GET_CUSTOMER_CHITS_REQUEST';
export const GET_CUSTOMER_CHITS_SUCCESS = 'GET_CUSTOMER_CHITS_SUCCESS';
export const GET_CUSTOMER_CHITS_FAILURE = 'GET_CUSTOMER_CHITS_FAILURE';
export const CREATE_CUSTOMER_CHIT_REQUEST = 'CREATE_CUSTOMER_CHIT_REQUEST';
export const CREATE_CUSTOMER_CHIT_SUCCESS = 'CREATE_CUSTOMER_CHIT_SUCCESS';
export const CREATE_CUSTOMER_CHIT_FAILURE = 'CREATE_CUSTOMER_CHIT_FAILURE';
export const MAKE_CHIT_PAYMENT_REQUEST = 'MAKE_CHIT_PAYMENT_REQUEST';
export const MAKE_CHIT_PAYMENT_SUCCESS = 'MAKE_CHIT_PAYMENT_SUCCESS';
export const MAKE_CHIT_PAYMENT_FAILURE = 'MAKE_CHIT_PAYMENT_FAILURE';
export const GET_CLOSED_CHITS_REQUEST = 'GET_CLOSED_CHITS_REQUEST';
export const GET_CLOSED_CHITS_SUCCESS = 'GET_CLOSED_CHITS_SUCCESS';
export const GET_CLOSED_CHITS_FAILURE = 'GET_CLOSED_CHITS_FAILURE';
export const CLOSE_CHIT_EARLY_REQUEST = 'CLOSE_CHIT_EARLY_REQUEST';
export const CLOSE_CHIT_EARLY_SUCCESS = 'CLOSE_CHIT_EARLY_SUCCESS';
export const CLOSE_CHIT_EARLY_FAILURE = 'CLOSE_CHIT_EARLY_FAILURE';
export const GET_CHIT_HISTORY_REQUEST = 'GET_CHIT_HISTORY_REQUEST';
export const GET_CHIT_HISTORY_SUCCESS = 'GET_CHIT_HISTORY_SUCCESS';
export const GET_CHIT_HISTORY_FAILURE = 'GET_CHIT_HISTORY_FAILURE';
export const GET_CHIT_PAYMENTS_REQUEST = 'GET_CHIT_PAYMENTS_REQUEST';
export const GET_CHIT_PAYMENTS_SUCCESS = 'GET_CHIT_PAYMENTS_SUCCESS';
export const GET_CHIT_PAYMENTS_FAILURE = 'GET_CHIT_PAYMENTS_FAILURE';

// Tax Master Types
export const GET_TAXES_REQUEST = 'GET_TAXES_REQUEST';
export const GET_TAXES_SUCCESS = 'GET_TAXES_SUCCESS';
export const GET_TAXES_FAILURE = 'GET_TAXES_FAILURE';
export const CREATE_TAX_REQUEST = 'CREATE_TAX_REQUEST';
export const CREATE_TAX_SUCCESS = 'CREATE_TAX_SUCCESS';
export const CREATE_TAX_FAILURE = 'CREATE_TAX_FAILURE';
export const UPDATE_TAX_REQUEST = 'UPDATE_TAX_REQUEST';
export const UPDATE_TAX_SUCCESS = 'UPDATE_TAX_SUCCESS';
export const UPDATE_TAX_FAILURE = 'UPDATE_TAX_FAILURE';
export const DELETE_TAX_REQUEST = 'DELETE_TAX_REQUEST';
export const DELETE_TAX_SUCCESS = 'DELETE_TAX_SUCCESS';
export const DELETE_TAX_FAILURE = 'DELETE_TAX_FAILURE';

// UI Types
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';

// Daily Rate Types
export const GET_DAILY_RATES_REQUEST = 'GET_DAILY_RATES_REQUEST';
export const GET_DAILY_RATES_SUCCESS = 'GET_DAILY_RATES_SUCCESS';
export const GET_DAILY_RATES_FAILURE = 'GET_DAILY_RATES_FAILURE';
export const CREATE_DAILY_RATE_REQUEST = 'CREATE_DAILY_RATE_REQUEST';
export const CREATE_DAILY_RATE_SUCCESS = 'CREATE_DAILY_RATE_SUCCESS';
export const CREATE_DAILY_RATE_FAILURE = 'CREATE_DAILY_RATE_FAILURE';
export const UPDATE_DAILY_RATE_REQUEST = 'UPDATE_DAILY_RATE_REQUEST';
export const UPDATE_DAILY_RATE_SUCCESS = 'UPDATE_DAILY_RATE_SUCCESS';
export const UPDATE_DAILY_RATE_FAILURE = 'UPDATE_DAILY_RATE_FAILURE';
export const DELETE_DAILY_RATE_REQUEST = 'DELETE_DAILY_RATE_REQUEST';
export const DELETE_DAILY_RATE_SUCCESS = 'DELETE_DAILY_RATE_SUCCESS';
export const DELETE_DAILY_RATE_FAILURE = 'DELETE_DAILY_RATE_FAILURE';

// Convert order to invoice types
export const CONVERT_ORDER_TO_INVOICE_REQUEST = 'CONVERT_ORDER_TO_INVOICE_REQUEST';
export const CONVERT_ORDER_TO_INVOICE_SUCCESS = 'CONVERT_ORDER_TO_INVOICE_SUCCESS';
export const CONVERT_ORDER_TO_INVOICE_FAILURE = 'CONVERT_ORDER_TO_INVOICE_FAILURE';

// Repair Order Types
export const GET_REPAIR_ORDERS_REQUEST = 'GET_REPAIR_ORDERS_REQUEST';
export const GET_REPAIR_ORDERS_SUCCESS = 'GET_REPAIR_ORDERS_SUCCESS';
export const GET_REPAIR_ORDERS_FAILURE = 'GET_REPAIR_ORDERS_FAILURE';
export const GET_REPAIR_ORDER_REQUEST = 'GET_REPAIR_ORDER_REQUEST';
export const GET_REPAIR_ORDER_SUCCESS = 'GET_REPAIR_ORDER_SUCCESS';
export const GET_REPAIR_ORDER_FAILURE = 'GET_REPAIR_ORDER_FAILURE';
export const CREATE_REPAIR_ORDER_REQUEST = 'CREATE_REPAIR_ORDER_REQUEST';
export const CREATE_REPAIR_ORDER_SUCCESS = 'CREATE_REPAIR_ORDER_SUCCESS';
export const CREATE_REPAIR_ORDER_FAILURE = 'CREATE_REPAIR_ORDER_FAILURE';
export const UPDATE_REPAIR_ORDER_REQUEST = 'UPDATE_REPAIR_ORDER_REQUEST';
export const UPDATE_REPAIR_ORDER_SUCCESS = 'UPDATE_REPAIR_ORDER_SUCCESS';
export const UPDATE_REPAIR_ORDER_FAILURE = 'UPDATE_REPAIR_ORDER_FAILURE';
export const UPDATE_REPAIR_ORDER_STATUS_REQUEST = 'UPDATE_REPAIR_ORDER_STATUS_REQUEST';
export const UPDATE_REPAIR_ORDER_STATUS_SUCCESS = 'UPDATE_REPAIR_ORDER_STATUS_SUCCESS';
export const UPDATE_REPAIR_ORDER_STATUS_FAILURE = 'UPDATE_REPAIR_ORDER_STATUS_FAILURE';
export const ADD_REPAIR_ORDER_PAYMENT_REQUEST = 'ADD_REPAIR_ORDER_PAYMENT_REQUEST';
export const ADD_REPAIR_ORDER_PAYMENT_SUCCESS = 'ADD_REPAIR_ORDER_PAYMENT_SUCCESS';
export const ADD_REPAIR_ORDER_PAYMENT_FAILURE = 'ADD_REPAIR_ORDER_PAYMENT_FAILURE';
export const MARK_REPAIR_ORDER_DELIVERED_REQUEST = 'MARK_REPAIR_ORDER_DELIVERED_REQUEST';
export const MARK_REPAIR_ORDER_DELIVERED_SUCCESS = 'MARK_REPAIR_ORDER_DELIVERED_SUCCESS';
export const MARK_REPAIR_ORDER_DELIVERED_FAILURE = 'MARK_REPAIR_ORDER_DELIVERED_FAILURE';
export const GET_REPAIR_ORDER_PAYMENTS_REQUEST = 'GET_REPAIR_ORDER_PAYMENTS_REQUEST';
export const GET_REPAIR_ORDER_PAYMENTS_SUCCESS = 'GET_REPAIR_ORDER_PAYMENTS_SUCCESS';
export const GET_REPAIR_ORDER_PAYMENTS_FAILURE = 'GET_REPAIR_ORDER_PAYMENTS_FAILURE';

// Outsource Types
export const OUTSOURCE_REPAIR_ORDER_REQUEST = 'OUTSOURCE_REPAIR_ORDER_REQUEST';
export const OUTSOURCE_REPAIR_ORDER_SUCCESS = 'OUTSOURCE_REPAIR_ORDER_SUCCESS';
export const OUTSOURCE_REPAIR_ORDER_FAILURE = 'OUTSOURCE_REPAIR_ORDER_FAILURE';
export const MARK_REPAIR_ORDER_RECEIVED_REQUEST = 'MARK_REPAIR_ORDER_RECEIVED_REQUEST';
export const MARK_REPAIR_ORDER_RECEIVED_SUCCESS = 'MARK_REPAIR_ORDER_RECEIVED_SUCCESS';
export const MARK_REPAIR_ORDER_RECEIVED_FAILURE = 'MARK_REPAIR_ORDER_RECEIVED_FAILURE';
export const ADD_GOLDSMITH_PAYMENT_REQUEST = 'ADD_GOLDSMITH_PAYMENT_REQUEST';
export const ADD_GOLDSMITH_PAYMENT_SUCCESS = 'ADD_GOLDSMITH_PAYMENT_SUCCESS';
export const ADD_GOLDSMITH_PAYMENT_FAILURE = 'ADD_GOLDSMITH_PAYMENT_FAILURE';
export const GET_OUTSOURCE_TIMELINE_REQUEST = 'GET_OUTSOURCE_TIMELINE_REQUEST';
export const GET_OUTSOURCE_TIMELINE_SUCCESS = 'GET_OUTSOURCE_TIMELINE_SUCCESS';
export const GET_OUTSOURCE_TIMELINE_FAILURE = 'GET_OUTSOURCE_TIMELINE_FAILURE';

// Expense Types
export const GET_EXPENSES_REQUEST = 'GET_EXPENSES_REQUEST';
export const GET_EXPENSES_SUCCESS = 'GET_EXPENSES_SUCCESS';
export const GET_EXPENSES_FAILURE = 'GET_EXPENSES_FAILURE';
export const GET_EXPENSE_REQUEST = 'GET_EXPENSE_REQUEST';
export const GET_EXPENSE_SUCCESS = 'GET_EXPENSE_SUCCESS';
export const GET_EXPENSE_FAILURE = 'GET_EXPENSE_FAILURE';
export const CREATE_EXPENSE_REQUEST = 'CREATE_EXPENSE_REQUEST';
export const CREATE_EXPENSE_SUCCESS = 'CREATE_EXPENSE_SUCCESS';
export const CREATE_EXPENSE_FAILURE = 'CREATE_EXPENSE_FAILURE';
export const UPDATE_EXPENSE_REQUEST = 'UPDATE_EXPENSE_REQUEST';
export const UPDATE_EXPENSE_SUCCESS = 'UPDATE_EXPENSE_SUCCESS';
export const UPDATE_EXPENSE_FAILURE = 'UPDATE_EXPENSE_FAILURE';
export const DELETE_EXPENSE_REQUEST = 'DELETE_EXPENSE_REQUEST';
export const DELETE_EXPENSE_SUCCESS = 'DELETE_EXPENSE_SUCCESS';
export const DELETE_EXPENSE_FAILURE = 'DELETE_EXPENSE_FAILURE';
export const SUBMIT_EXPENSE_REQUEST = 'SUBMIT_EXPENSE_REQUEST';
export const SUBMIT_EXPENSE_SUCCESS = 'SUBMIT_EXPENSE_SUCCESS';
export const SUBMIT_EXPENSE_FAILURE = 'SUBMIT_EXPENSE_FAILURE';
export const APPROVE_EXPENSE_REQUEST = 'APPROVE_EXPENSE_REQUEST';
export const APPROVE_EXPENSE_SUCCESS = 'APPROVE_EXPENSE_SUCCESS';
export const APPROVE_EXPENSE_FAILURE = 'APPROVE_EXPENSE_FAILURE';
export const REJECT_EXPENSE_REQUEST = 'REJECT_EXPENSE_REQUEST';
export const REJECT_EXPENSE_SUCCESS = 'REJECT_EXPENSE_SUCCESS';
export const REJECT_EXPENSE_FAILURE = 'REJECT_EXPENSE_FAILURE';
export const GET_EXPENSE_STATS_REQUEST = 'GET_EXPENSE_STATS_REQUEST';
export const GET_EXPENSE_STATS_SUCCESS = 'GET_EXPENSE_STATS_SUCCESS';
export const GET_EXPENSE_STATS_FAILURE = 'GET_EXPENSE_STATS_FAILURE';

// Expense Category Types
export const GET_EXPENSE_CATEGORIES_REQUEST = 'GET_EXPENSE_CATEGORIES_REQUEST';
export const GET_EXPENSE_CATEGORIES_SUCCESS = 'GET_EXPENSE_CATEGORIES_SUCCESS';
export const GET_EXPENSE_CATEGORIES_FAILURE = 'GET_EXPENSE_CATEGORIES_FAILURE';
export const GET_EXPENSE_CATEGORY_REQUEST = 'GET_EXPENSE_CATEGORY_REQUEST';
export const GET_EXPENSE_CATEGORY_SUCCESS = 'GET_EXPENSE_CATEGORY_SUCCESS';
export const GET_EXPENSE_CATEGORY_FAILURE = 'GET_EXPENSE_CATEGORY_FAILURE';
export const CREATE_EXPENSE_CATEGORY_REQUEST = 'CREATE_EXPENSE_CATEGORY_REQUEST';
export const CREATE_EXPENSE_CATEGORY_SUCCESS = 'CREATE_EXPENSE_CATEGORY_SUCCESS';
export const CREATE_EXPENSE_CATEGORY_FAILURE = 'CREATE_EXPENSE_CATEGORY_FAILURE';
export const UPDATE_EXPENSE_CATEGORY_REQUEST = 'UPDATE_EXPENSE_CATEGORY_REQUEST';
export const UPDATE_EXPENSE_CATEGORY_SUCCESS = 'UPDATE_EXPENSE_CATEGORY_SUCCESS';
export const UPDATE_EXPENSE_CATEGORY_FAILURE = 'UPDATE_EXPENSE_CATEGORY_FAILURE';
export const DELETE_EXPENSE_CATEGORY_REQUEST = 'DELETE_EXPENSE_CATEGORY_REQUEST';
export const DELETE_EXPENSE_CATEGORY_SUCCESS = 'DELETE_EXPENSE_CATEGORY_SUCCESS';
export const DELETE_EXPENSE_CATEGORY_FAILURE = 'DELETE_EXPENSE_CATEGORY_FAILURE';
export const GET_CATEGORY_HIERARCHY_REQUEST = 'GET_CATEGORY_HIERARCHY_REQUEST';
export const GET_CATEGORY_HIERARCHY_SUCCESS = 'GET_CATEGORY_HIERARCHY_SUCCESS';
export const GET_CATEGORY_HIERARCHY_FAILURE = 'GET_CATEGORY_HIERARCHY_FAILURE';

// Expense Vendor Types
export const GET_EXPENSE_VENDORS_REQUEST = 'GET_EXPENSE_VENDORS_REQUEST';
export const GET_EXPENSE_VENDORS_SUCCESS = 'GET_EXPENSE_VENDORS_SUCCESS';
export const GET_EXPENSE_VENDORS_FAILURE = 'GET_EXPENSE_VENDORS_FAILURE';
export const GET_EXPENSE_VENDOR_REQUEST = 'GET_EXPENSE_VENDOR_REQUEST';
export const GET_EXPENSE_VENDOR_SUCCESS = 'GET_EXPENSE_VENDOR_SUCCESS';
export const GET_EXPENSE_VENDOR_FAILURE = 'GET_EXPENSE_VENDOR_FAILURE';
export const CREATE_EXPENSE_VENDOR_REQUEST = 'CREATE_EXPENSE_VENDOR_REQUEST';
export const CREATE_EXPENSE_VENDOR_SUCCESS = 'CREATE_EXPENSE_VENDOR_SUCCESS';
export const CREATE_EXPENSE_VENDOR_FAILURE = 'CREATE_EXPENSE_VENDOR_FAILURE';
export const UPDATE_EXPENSE_VENDOR_REQUEST = 'UPDATE_EXPENSE_VENDOR_REQUEST';
export const UPDATE_EXPENSE_VENDOR_SUCCESS = 'UPDATE_EXPENSE_VENDOR_SUCCESS';
export const UPDATE_EXPENSE_VENDOR_FAILURE = 'UPDATE_EXPENSE_VENDOR_FAILURE';
export const DELETE_EXPENSE_VENDOR_REQUEST = 'DELETE_EXPENSE_VENDOR_REQUEST';
export const DELETE_EXPENSE_VENDOR_SUCCESS = 'DELETE_EXPENSE_VENDOR_SUCCESS';
export const DELETE_EXPENSE_VENDOR_FAILURE = 'DELETE_EXPENSE_VENDOR_FAILURE';

// Expense Type Types
export const GET_EXPENSE_TYPES_REQUEST = 'GET_EXPENSE_TYPES_REQUEST';
export const GET_EXPENSE_TYPES_SUCCESS = 'GET_EXPENSE_TYPES_SUCCESS';
export const GET_EXPENSE_TYPES_FAILURE = 'GET_EXPENSE_TYPES_FAILURE';
export const GET_EXPENSE_TYPE_REQUEST = 'GET_EXPENSE_TYPE_REQUEST';
export const GET_EXPENSE_TYPE_SUCCESS = 'GET_EXPENSE_TYPE_SUCCESS';
export const GET_EXPENSE_TYPE_FAILURE = 'GET_EXPENSE_TYPE_FAILURE';
export const CREATE_EXPENSE_TYPE_REQUEST = 'CREATE_EXPENSE_TYPE_REQUEST';
export const CREATE_EXPENSE_TYPE_SUCCESS = 'CREATE_EXPENSE_TYPE_SUCCESS';
export const CREATE_EXPENSE_TYPE_FAILURE = 'CREATE_EXPENSE_TYPE_FAILURE';
export const UPDATE_EXPENSE_TYPE_REQUEST = 'UPDATE_EXPENSE_TYPE_REQUEST';
export const UPDATE_EXPENSE_TYPE_SUCCESS = 'UPDATE_EXPENSE_TYPE_SUCCESS';
export const UPDATE_EXPENSE_TYPE_FAILURE = 'UPDATE_EXPENSE_TYPE_FAILURE';
export const DELETE_EXPENSE_TYPE_REQUEST = 'DELETE_EXPENSE_TYPE_REQUEST';
export const DELETE_EXPENSE_TYPE_SUCCESS = 'DELETE_EXPENSE_TYPE_SUCCESS';
export const DELETE_EXPENSE_TYPE_FAILURE = 'DELETE_EXPENSE_TYPE_FAILURE';

// User Management Types
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAILURE = 'CHANGE_USER_PASSWORD_FAILURE';

// Role Types
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'CREATE_ROLE_FAILURE';
export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'UPDATE_ROLE_FAILURE';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

// Role Permission Types
export const GET_ROLE_PERMISSIONS_REQUEST = 'GET_ROLE_PERMISSIONS_REQUEST';
export const GET_ROLE_PERMISSIONS_SUCCESS = 'GET_ROLE_PERMISSIONS_SUCCESS';
export const GET_ROLE_PERMISSIONS_FAILURE = 'GET_ROLE_PERMISSIONS_FAILURE';
export const UPDATE_ROLE_PERMISSIONS_REQUEST = 'UPDATE_ROLE_PERMISSIONS_REQUEST';
export const UPDATE_ROLE_PERMISSIONS_SUCCESS = 'UPDATE_ROLE_PERMISSIONS_SUCCESS';
export const UPDATE_ROLE_PERMISSIONS_FAILURE = 'UPDATE_ROLE_PERMISSIONS_FAILURE';
export const GET_AVAILABLE_MODULES_REQUEST = 'GET_AVAILABLE_MODULES_REQUEST';
export const GET_AVAILABLE_MODULES_SUCCESS = 'GET_AVAILABLE_MODULES_SUCCESS';
export const GET_AVAILABLE_MODULES_FAILURE = 'GET_AVAILABLE_MODULES_FAILURE';
